import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';
import toast from 'react-hot-toast';
import { billingItemsActions } from './billingItemsReducer';

const initialState = {
  loading: false,
  connectionsList: [],
  connectionActionForHeader: []
};
const connections = createSlice({
  name: 'connections',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getList(state, action) {
      return {
        ...state,
        connectionsList: action.payload?.data?.result,
        count: action.payload?.data?.count
      };
    },
    getConnectionActionForHeader(state, action) {
      return {
        ...state,
        connectionActionForHeader: action.payload?.data?.result,
        count: action.payload?.data?.count
      };
    },
    getById(state, action) {
      return {
        ...state,
        providerInfo: action.payload
      };
    }
  }
});

export const connectionsActions = connections.actions;

export const getConnectionAction = (data) => async (dispatch) => {
  dispatch(connectionsActions.setLoading(true));
  try {
    const res = await api.post(`api/CompanyConnection/ReceivedFilter`, data);
    if (res.status === 200 && res?.data) {
      dispatch(connectionsActions.getList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(connectionsActions.setLoading(false));
  }
};
export const getConnectionActionForHeader = (data) => async (dispatch) => {
  dispatch(connectionsActions.setLoading(true));
  try {
    const res = await api.post(`api/CompanyConnection/ReceivedFilter`, data);
    if (res.status === 200 && res?.data) {
      dispatch(connectionsActions.getConnectionActionForHeader(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(connectionsActions.setLoading(false));
  }
};

export const clearConnections = () => async (dispatch) => {
  dispatch(billingItemsActions.getList(''));
};

export const RejectInvitation = (id, setDialog) => async () => {
  try {
    const res = await api.post(`api/CompanyConnection/reject`, { id });
    if (res.status === 200) {
      setDialog('');
      toast.success('Action successfully!!!');
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export const acceptInvitation = (id, setDialog) => async () => {
  try {
    const res = await api.post(`api/CompanyConnection/accept`, { id });
    if (res.status === 200) {
      if (setDialog) {
        setDialog('');
      }
      toast.success('Accept successfully!!!');
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export default connections.reducer;
